import { render, staticRenderFns } from "./personal-case-detail.vue?vue&type=template&id=0ece7674&scoped=true"
import script from "./personal-case-detail.vue?vue&type=script&lang=js"
export * from "./personal-case-detail.vue?vue&type=script&lang=js"
import style0 from "./personal-case-detail.vue?vue&type=style&index=0&id=0ece7674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece7674",
  null
  
)

export default component.exports